import React from 'react'
import { Typography, Link, Grid, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px',
    [theme.breakpoints.up('sm')]: {
      padding: '120px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '160px',
    },
  },
  sectionTitle: {
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: 'bold',
    color: 'white',
    fontSize: '2rem',
  },
  image: {
    height: '80%',
  },
  textSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '24rem',
    [theme.breakpoints.only('sm')]: {
      minHeight: '12rem',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: '10rem',
    },
    '& h2': {
      marginBottom: '1rem',
    },
  },
  imageSection: {
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  link: {
    fontWeight: 'normal',
    color: 'white',
  },
  innerContainer: {
    background: theme.palette.primary.main,
    borderRadius: '1rem',
    padding: '40px',
  },
  linkSection: {
    marginTop: '2rem',
  },
  button: {
    textDecoration: 'none',
    background: 'white',
    color: theme.palette.primary.main,
    fontFamily: theme.typography.body1.fontFamily,
    fontSize: '1rem',
    textTransform: 'capitalize',
    marginRight: '2rem',
    fontWeight: 'normal',
    borderRadius: '.4rem',
    letterSpacing: 'normal',
    padding: '12px',
    '&:hover': {
      background: 'white',
    },
  },
}))

function JoinCommunitySection(): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Grid container spacing={4} className={classes.innerContainer}>
        <Grid item xs={12} md={9} className={classes.textSection}>
          <Typography className={classes.sectionTitle} variant="h2">
            Tokenized Crypto Enthusiast Community
          </Typography>
          <Typography variant="subtitle2">
            Monthly subscriptions are for boomers - the cryptotesters subscription is tokenized.
            $TESTER tokens are yours and will always remain yours. You can sell them whenever you
            want to exit the community.
          </Typography>
          <div className={classes.linkSection}>
            <Button className={classes.button} endIcon={<ArrowForwardIcon />} href="#">
              Join the community
            </Button>
            <Link color="textSecondary" underline="hover" className={classes.link} href="#">
              Learn more
            </Link>
          </div>
        </Grid>
        <Grid item xs={12} md={3} className={classes.imageSection}>
          <img src={'/community-icon.png'} className={classes.image} />
        </Grid>
      </Grid>
    </div>
  )
}

export default JoinCommunitySection
